import React,{useState} from 'react'
import {useMediaQuery} from "@mui/material";
import {Typography,useTheme,Paper,Dialog} from "@mui/material";
import { Grid2 } from '@mui/material'
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import "./Header.css"
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Input from "../Input/Input";

const personalinfo = [
  { label: "First Name", name: "firstname" },
  { label: "Last Name", name: "lastname" },
  { label: "Mobile", name: "mobile" },
  { label: "Email", name: "email" },
]

const fields = [
  { label: "Commodity", name: "commodity" },
  { label: "Packing", name: "packing" },
  { label: "Delivery", name: "delivery" },
  { label: "Price", name: "price" },
  { label: "Payment Terms", name: "payment" },
  { label: "Quantity Per Container", name: "quantity" },
  { label: "Other Terms & Conditions", name: "conditions" },
];

export function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  
  
  const [formData, setFormData] = useState({firstname:"",lastname:"",mobile:"",email:"",commodity: "", packing: "", delivery: "",price:"" ,payment: "", quantity: "", conditions: ""});
  const handleClickOpen = () => { setOpen(true); };
  const handleClose = () => { setOpen(false);setFormData({firstname:"",lastname:"",mobile:"",email:"",commodity: "", packing: "", delivery: "",price:"" ,payment: "", quantity: "", conditions: ""}) };
  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value })};
  const handleSubmit = (e) => { e.preventDefault();console.log("Form Data:", formData);};

  return (
    <>
    {!isMobile &&
    <Grid2 className='MainHeaderDate'   height="10vh" sx={{backgroundColor:"#041e42;"}} >
            {/* <Grid2 width="30%">
            <img src={mainlogo} alt="GBG logo" style={{ height: "60px",marginTop:"10px" }} />
            </Grid2> */}
            <Grid2 width="20%" className="SubHeaderDate">
              <CallIcon  sx={{color:"#fff",border:"2px solid #fff",fontSize:"40px",borderRadius:"20px",padding:"3px"}}/> 
              <Grid2 className="maintext" >
              24/7 Response Time<br/>
              <b>+91-76758 09054</b>
              </Grid2>
            </Grid2>
            <Grid2 width="20%" className="SubHeaderDate">
              <EmailIcon  sx={{color:"#fff",border:"2px solid #fff",fontSize:"40px",borderRadius:"20px",padding:"3px"}}/> 
              <Grid2 className="maintext" >
               Send Your Query<br/>
              <b>sales@growbeyondglobal.com</b>
              </Grid2>
            </Grid2>
            <>
              <Button variant="contained" sx={{backgroundColor:"#154A72",margin:"12px 0px",borderRadius:"20px"}} onClick={handleClickOpen} >Request a Quote</Button>
              <Dialog component="form" onSubmit={handleSubmit} open={open}  onClose={handleClose} maxWidth="sm" fullScreen={isMobile} aria-labelledby="responsive-dialog-title"  fullWidth PaperProps={{sx:{width:"90%",height:"90%" },sm:{width:"80%",height:"80%" }}}  >
                 <DialogTitle>REQUEST A QUOTE</DialogTitle>
                 <DialogContent sx={{overflowY:"scroll"}}  >
                    <DialogContentText>
                          Let's Connect with GBG-Grow Beyond Global
                    </DialogContentText>
                    <Grid2 container sx={{flexDirection: "column",gap:"20px" }}>
                      <Grid2 container component={Paper} elevation={4} sx={{padding:"10px",gap:"10px"}} >
                        <Typography sx={{fontSize:"20px",fontWeight:"600"}}>Personal Info</Typography>
                        <Grid2 container sx={{justifyContent:"space-between",alignItems:"center",borderRadius:"5px"}}>  
                          {personalinfo.map((field, index) =>{return(
                            <Grid2 key={index} sx={{display: "flex", alignItems:"flex-start", flexDirection:"column",width:"49%"}}>
                              <label style={{ fontSize: "20px", fontWeight: "500",fontSize:"14px",fontFamily:"sans-serif"}}>{field.label}:</label>
                              <Input placeholder={field.name} name={field.name} value={formData[field.name]} onChange={handleChange}/>
                            </Grid2>
                        )})}
                        </Grid2>
                      </Grid2>
                      <Grid2 container component={Paper} elevation={4} sx={{padding:"10px",gap:"10px"}} >
                        <Typography sx={{fontSize:"20px",fontWeight:"600"}}>Request Quote</Typography>
                        <Grid2 sx={{width:"100%"}}>  
                        {fields.map((field, index) =>{return(
                          <Grid2 key={index} sx={{display: "flex", alignItems:"flex-start", flexDirection:"column" }}>
                            <label style={{ fontSize: "20px", fontWeight: "500",fontSize:"14px",fontFamily:"sans-serif"}}>{field.label}:</label>
                            <Input placeholder={field.name} name={field.name} value={formData[field.name]} onChange={handleChange}/>
                          </Grid2>
                        )})}
                      </Grid2>
                    </Grid2>                   
                    </Grid2>
                 </DialogContent>
                 <DialogActions>
                 <Button type="submit" variant="contained" color="success">Submit</Button>
                 <Button onClick={handleClose}  variant="contained" color="error" >Close</Button>
                 </DialogActions>
             </Dialog>
             </>
    </Grid2>}
    {isMobile &&
    <Grid2 className='MainHeaderDate' height="8vh" sx={{backgroundColor:"#041e42",justifyContent:"space-evenly"}} >
            {/* <Grid2 width="30%">
            <img src={mainlogo} alt="GBG logo" style={{ height: "60px",marginTop:"10px" }} />
            </Grid2> */}
            <Grid2 width="max-content" className="SubHeaderDate" sx={{justifyContent:"flex-start !important",gap:"10px !important"}}>
              <CallIcon  sx={{color:"#fff",border:"2px solid #fff",fontSize:"30px",borderRadius:"20px",padding:"3px"}}/> 
              <Grid2 className="maintext" sx={{fontSize:"12px !important"}} >
              24/7 Response Time<br/>
              <b>+91-76758 09054</b>
              </Grid2>
            </Grid2>
            <Grid2 width="max-content" className="SubHeaderDate" sx={{justifyContent:"flex-start !important",gap:"10px !important"}}>
              <EmailIcon  sx={{color:"#fff",border:"2px solid #fff",fontSize:"30px",borderRadius:"20px",padding:"3px"}}/> 
              <Grid2 className="maintext" sx={{fontSize:"12px !important"}} >
               Send Your Query<br/>
              <b>sales@growbeyondglobal.com</b>
              </Grid2>
            </Grid2>
    </Grid2>}
    </>
  )
}

